import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';

/**
 * Whether the API is reachable and ready.
 *
 * Not a diagnostic curiosity: the console is useless without the API, and a church
 * administrator who can see that Trinity itself is down will stop retrying a form and
 * wait, instead of re-entering the same contribution four times.
 */

export interface HealthReport {
  status: 'ok' | 'degraded';
  uptimeSeconds: number;
  checks: { database: 'ok' | 'unavailable' };
}

export const useHealth = () =>
  useQuery({
    queryKey: ['health'],
    queryFn: () =>
      api.get<HealthReport>('/health/ready', { withoutChurch: true }),
    refetchInterval: 60_000,
    // Never retried: this query's failure is the answer, and retrying it three times
    // means a minute of "checking" when the truthful answer is available immediately.
    retry: false,
    staleTime: 30_000,
  });
